webpackJsonp([59246933105914],{

/***/ 805:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"member_item":"src-components-team-item----TeamItem-module---member_item---2zteS","profile_row":"src-components-team-item----TeamItem-module---profile_row---2dgMW","photo_col":"src-components-team-item----TeamItem-module---photo_col---3e03m","profile":"src-components-team-item----TeamItem-module---profile---3JeGf","profile_bio":"src-components-team-item----TeamItem-module---profile_bio---15g7Q","job_title":"src-components-team-item----TeamItem-module---job_title---2s77p","name":"src-components-team-item----TeamItem-module---name---lrdus","degree":"src-components-team-item----TeamItem-module---degree---138V9","description":"src-components-team-item----TeamItem-module---description---3_rNf","contact_details":"src-components-team-item----TeamItem-module---contact_details---3qSO4","member_link_list":"src-components-team-item----TeamItem-module---member_link_list---1YR3K","member_link_item":"src-components-team-item----TeamItem-module---member_link_item---2t-NN","member_link":"src-components-team-item----TeamItem-module---member_link---3HZuA","show_more":"src-components-team-item----TeamItem-module---show_more---3dV66"};

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _wang = __webpack_require__(1724);
	
	var _wang2 = _interopRequireDefault(_wang);
	
	var _wanlapa = __webpack_require__(1725);
	
	var _wanlapa2 = _interopRequireDefault(_wanlapa);
	
	var _TeamItemModule = __webpack_require__(805);
	
	var _TeamItemModule2 = _interopRequireDefault(_TeamItemModule);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _helpers = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamItem = function (_React$Component) {
		_inherits(TeamItem, _React$Component);
	
		function TeamItem(props) {
			_classCallCheck(this, TeamItem);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.handleTruncate = function () {
				var showAll = _this.state.showAll;
	
	
				_this.setState({ showAll: !showAll });
			};
	
			_this.state = {
				showAll: false
			};
			return _this;
		}
	
		TeamItem.prototype.render = function render() {
			var _this2 = this;
	
			var showAll = this.state.showAll;
			var _props = this.props,
			    photo = _props.photo,
			    job_title = _props.job_title,
			    name = _props.name,
			    degree = _props.degree,
			    bio = _props.bio,
			    email = _props.email,
			    pubMed = _props.pubMed,
			    researchGate = _props.researchGate,
			    mahidolProfile = _props.mahidolProfile,
			    linkedInProfile = _props.linkedInProfile;
			var props = this.props;
	
	
			return _react2.default.createElement(
				"div",
				{ className: "col-12 col-md-6 " + _TeamItemModule2.default.member_item },
				_react2.default.createElement(
					"div",
					{ className: "row justify-content-between " + _TeamItemModule2.default.profile_row },
					_react2.default.createElement(
						"div",
						{ className: _TeamItemModule2.default.photo_col },
						_react2.default.createElement("img", { alt: name, src: photo.sizes.src }),
						_react2.default.createElement(
							"ul",
							{ className: _TeamItemModule2.default.member_link_list },
							props.links && props.links.map(function (link, i) {
								return _react2.default.createElement(
									"li",
									{
										key: "link-" + (i + 1),
										className: _TeamItemModule2.default.member_link_item
									},
									_react2.default.createElement(
										"a",
										{
											href: link.url,
											className: _TeamItemModule2.default.member_link
										},
										link.label
									)
								);
							})
						)
					),
					_react2.default.createElement(
						"div",
						{ className: _TeamItemModule2.default.profile },
						_react2.default.createElement(
							"small",
							{ className: _TeamItemModule2.default.job_title },
							job_title
						),
						_react2.default.createElement(
							"h4",
							{ className: _TeamItemModule2.default.name },
							props.name
						),
						_react2.default.createElement(
							"small",
							{ className: _TeamItemModule2.default.degree },
							degree
						)
					),
					_react2.default.createElement(
						"div",
						{ className: _TeamItemModule2.default.profile_bio },
						_react2.default.createElement(
							"p",
							{ className: _TeamItemModule2.default.description },
							props.bio && (!showAll ? (0, _helpers.truncate)(props.bio, 120, true) : props.bio),
							" ",
							props.bio && props.bio.length > 120 && _react2.default.createElement(
								"button",
								{
									onClick: function onClick() {
										return _this2.handleTruncate();
									},
									className: _TeamItemModule2.default.show_more
								},
								!showAll ? "show more ▾" : "« show less"
							)
						),
						_react2.default.createElement(
							"div",
							{ className: _TeamItemModule2.default.contact_details },
							props.email && _react2.default.createElement(
								"span",
								null,
								_react2.default.createElement("i", { className: "envelope" }),
								props.email
							)
						)
					)
				)
			);
		};
	
		return TeamItem;
	}(_react2.default.Component);
	
	exports.default = TeamItem;
	module.exports = exports["default"];

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"leader_item":"src-components-team-leader-item----TeamLeaderItem-module---leader_item---130C0","photo_col":"src-components-team-leader-item----TeamLeaderItem-module---photo_col---3YqnW","profile":"src-components-team-leader-item----TeamLeaderItem-module---profile---1vAj4","job_title":"src-components-team-leader-item----TeamLeaderItem-module---job_title---3lH3g","name":"src-components-team-leader-item----TeamLeaderItem-module---name---2YmQi","degree":"src-components-team-leader-item----TeamLeaderItem-module---degree---14CZC","description":"src-components-team-leader-item----TeamLeaderItem-module---description---2eSpm","contact_details":"src-components-team-leader-item----TeamLeaderItem-module---contact_details---HSi3E","member_link_list":"src-components-team-leader-item----TeamLeaderItem-module---member_link_list---c2cQN","member_link_item":"src-components-team-leader-item----TeamLeaderItem-module---member_link_item---c1Yik","member_link":"src-components-team-leader-item----TeamLeaderItem-module---member_link---1orWA"};

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TeamLeaderItemModule = __webpack_require__(283);
	
	var _TeamLeaderItemModule2 = _interopRequireDefault(_TeamLeaderItemModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkup(value) {
		return {
			__html: value
		};
	}
	
	var TeamLeaderItem = function TeamLeaderItem(_ref) {
		var locale = _ref.locale,
		    photo = _ref.photo,
		    slug = _ref.slug,
		    job_title = _ref.job_title,
		    researchInterests = _ref.researchInterests,
		    name = _ref.name,
		    degree = _ref.degree,
		    bio = _ref.bio,
		    email = _ref.email,
		    profile_url = _ref.profile_url,
		    pubMed = _ref.pubMed,
		    researchGate = _ref.researchGate,
		    mahidolProfile = _ref.mahidolProfile,
		    linkedInProfile = _ref.linkedInProfile;
		return _react2.default.createElement(
			"div",
			{ className: "col-12 " + _TeamLeaderItemModule2.default.leader_item },
			_react2.default.createElement(
				"div",
				{ className: "row justify-content-between" },
				_react2.default.createElement("div", {
					className: _TeamLeaderItemModule2.default.photo_col,
					style: {
						backgroundImage: "url(" + photo + ")"
					}
				}),
				_react2.default.createElement(
					"div",
					{ className: _TeamLeaderItemModule2.default.profile },
					_react2.default.createElement(
						"small",
						{ className: _TeamLeaderItemModule2.default.job_title },
						job_title,
						" | ",
						researchInterests[0].title
					),
					slug ? _react2.default.createElement(
						"h4",
						{ className: _TeamLeaderItemModule2.default.name },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{ to: "/" + locale + "/team/" + slug },
							name
						)
					) : _react2.default.createElement(
						"h4",
						{ className: _TeamLeaderItemModule2.default.name },
						name
					),
					_react2.default.createElement(
						"small",
						{ className: _TeamLeaderItemModule2.default.degree },
						degree
					),
					_react2.default.createElement("span", {
						className: _TeamLeaderItemModule2.default.description,
						dangerouslySetInnerHTML: createMarkup(bio.html)
					}),
					_react2.default.createElement(
						"div",
						{ className: _TeamLeaderItemModule2.default.contact_details },
						email && _react2.default.createElement(
							"span",
							null,
							_react2.default.createElement("i", { className: "envelope" }),
							email
						)
					),
					_react2.default.createElement(
						"ul",
						{ className: _TeamLeaderItemModule2.default.member_link_list },
						pubMed && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: pubMed,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"Publications"
							)
						),
						researchGate && researchGate !== "-" && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: researchGate,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"ResearchGate"
							)
						),
						mahidolProfile && mahidolProfile !== "-" && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: mahidolProfile,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"Mahidol Profile"
							)
						),
						linkedInProfile && linkedInProfile !== "-" && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: linkedInProfile,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"LinkedIn"
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = TeamLeaderItem;
	module.exports = exports["default"];

/***/ }),

/***/ 1724:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wang.e1c05633.jpg";

/***/ }),

/***/ 1725:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wanlapa.f4917d77.jpg";

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wide_row":"src-styles----team-module---wide_row---3Uiqk","hr_long":"src-styles----team-module---hr_long---3tXeJ","small_item":"src-styles----team-module---small_item---1SkM2","career_list":"src-styles----team-module---career_list---2wGTR","jumbo_p":"src-styles----team-module---jumbo_p---1B3Xi","career_row":"src-styles----team-module---career_row---2Qg2t","go_back":"src-styles----team-module---go_back---12Z2J"};

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallToAction = __webpack_require__(38);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _subNav = __webpack_require__(73);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	var _teamLeaderItem = __webpack_require__(244);
	
	var _teamLeaderItem2 = _interopRequireDefault(_teamLeaderItem);
	
	var _teamItem = __webpack_require__(665);
	
	var _teamItem2 = _interopRequireDefault(_teamItem);
	
	var _reactScroll = __webpack_require__(48);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _teamModule = __webpack_require__(288);
	
	var _teamModule2 = _interopRequireDefault(_teamModule);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Team = function Team(_ref) {
		var transition = _ref.transition,
		    data = _ref.data,
		    location = _ref.location;
	
		// const teamData = data.allMvruJson.edges[0].node.team;
		var pisList = data.pis.edges;
		var researchersList = data.researchers.edges;
		var adminList = data.admin.edges;
		var cta = data.cta.edges[0].node;
		var pageTitle = data.pageSettings.pageTitle;
		var metaDescription = data.pageSettings.metaDescription.metaDescription;
		var locale = data.pageSettings.node_locale;
	
		// const { leaders } = teamData.staff;
	
	
		var navList = [{
			label: locale === "th" ? "ผู้วิจัยหลัก" : "Principal Investigators",
			name: "leaders"
		}, {
			label: locale === "th" ? "นักวิจัย/นักเทคนิค" : "Researcher/Technician",
			name: "researchers"
		}, {
			label: locale === "th" ? "ฝ่ายบริหารจัดการ" : "Administrator",
			name: "admin"
		}];
	
		var itemsLeaders = pisList.map(function (_ref2, i) {
			var node = _ref2.node;
	
			return _react2.default.createElement(_teamLeaderItem2.default, {
				key: "leader-" + i,
				alt: !(i % 2),
				slug: node.slug,
				locale: node.node_locale,
				photo: node.profilePicture.sizes.src,
				job_title: node.jobTitle,
				researchInterests: node.researchInterests,
				name: node.fullName,
				degree: node.academicDegree,
				bio: node.shortBio.content,
				email: node.email,
				pubMed: node.pubMedPublications,
				researchGate: node.researchGateUrl,
				mahidolProfile: node.mahidolProfileUrl,
				linkedInProfile: node.linkedInUrl
			});
		});
		var smallItems = researchersList.map(function (_ref3, ixx) {
			var node = _ref3.node;
	
			return _react2.default.createElement(_teamItem2.default, {
				className: _teamModule2.default.small_item,
				key: "staff-" + ixx,
				alt: !(ixx % 2),
				photo: node.profilePicture,
				job_title: node.jobTitle,
				name: node.fullName,
				degree: node.academicDegree,
				bio: node.shortBio.shortBio,
				email: node.email,
				pubMed: node.pubMedPublications,
				researchGate: node.researchGateUrl,
				mahidolProfile: node.mahidolProfileUrl,
				linkedInProfile: node.linkedInUrl
			});
		});
		var adminItems = adminList.map(function (_ref4, ixx) {
			var node = _ref4.node;
	
			return _react2.default.createElement(_teamItem2.default, {
				className: _teamModule2.default.small_item,
				key: "staff-" + ixx,
				alt: !(ixx % 2),
				photo: node.profilePicture,
				job_title: node.jobTitle,
				name: node.fullName,
				degree: node.academicDegree,
				bio: node.shortBio.shortBio,
				email: node.email,
				researchGate: node.researchGateUrl,
				mahidolProfile: node.mahidolProfileUrl,
				linkedInProfile: node.linkedInUrl
			});
		});
	
		return _react2.default.createElement(
			_PageWrapper2.default,
			{
				locale: locale,
				location: location,
				data: data.layout.edges[0].node
			},
			_react2.default.createElement(
				"main",
				{ role: "main", style: transition && transition.style },
				_react2.default.createElement(_reactHelmet2.default, { title: pageTitle + " | Mahidol Vivax Research Unit" }),
				_react2.default.createElement(
					_Jumbotron2.default,
					{
						className: "mb-0",
						textAlign: "text-center",
						contentAlign: "justify-content-md-center"
					},
					_react2.default.createElement(
						"h1",
						null,
						pageTitle
					),
					_react2.default.createElement(
						"p",
						{ className: _teamModule2.default.jumbo_p },
						metaDescription
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "grey_bg ", style: { position: "relative" } },
					_react2.default.createElement(
						"div",
						{
							className: "container",
							style: { transform: "translateY(-50%)" }
						},
						_react2.default.createElement(
							"div",
							{ className: "row justify-content-center" },
							_react2.default.createElement(
								"div",
								{ className: "col-10 col-md-6 col-lg-10" },
								_react2.default.createElement(_subNav2.default, {
									scroll: true,
									navList: navList,
									handleClick: function handleClick() {}
								})
							)
						)
					),
					_react2.default.createElement(
						_reactScroll.Element,
						{ name: "leaders", className: "element mt-lg-0", style: { marginTop: "-2rem" } },
						_react2.default.createElement(
							"div",
							{
								className: "container " + _teamModule2.default.no_padding,
								id: "leaders"
							},
							_react2.default.createElement(
								"div",
								{ className: _teamModule2.default.wide_row },
								_react2.default.createElement(
									"div",
									{ style: { width: "100%" } },
									_react2.default.createElement(
										"h2",
										null,
										locale === "th" ? "ผู้วิจัยหลัก" : "Principal Investigators"
									)
								),
								itemsLeaders
							)
						)
					),
					_react2.default.createElement(
						_reactScroll.Element,
						{ name: "researchers", className: "element" },
						_react2.default.createElement(
							"div",
							{ className: "container " + _teamModule2.default.no_padding },
							_react2.default.createElement("a", { id: "second" }),
							_react2.default.createElement(
								"div",
								{ className: _teamModule2.default.wide_row },
								_react2.default.createElement(
									"div",
									{ style: { width: "100%" } },
									_react2.default.createElement(
										"h2",
										null,
										locale === "th" ? "นักวิจัย/นักเทคนิค" : "Researcher / Technicians"
									)
								),
								smallItems
							)
						)
					),
					_react2.default.createElement(
						_reactScroll.Element,
						{ name: "admin", className: "element" },
						_react2.default.createElement(
							"div",
							{ className: "pb-2 container " + _teamModule2.default.no_padding },
							_react2.default.createElement("a", { id: "second" }),
							_react2.default.createElement(
								"div",
								{ className: _teamModule2.default.wide_row },
								_react2.default.createElement(
									"div",
									{ style: { width: "100%" } },
									_react2.default.createElement(
										"h2",
										null,
										locale === "th" ? "ฝ่ายบริหารจัดการ" : "Administrator"
									)
								),
								adminItems
							)
						)
					)
				),
				_react2.default.createElement(_CallToAction2.default, {
					className: "my-5",
					leadText: cta.leadingText,
					text: cta.content.childMarkdownRemark.html,
					buttonLabel: cta.buttonLabel,
					destination: "/" + locale + cta.linkTo,
					arrow: true
				})
			)
		);
	};
	
	exports.default = Team;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-team-template-js-24b8d11301f369db4992.js